import { DispatchLoading, DispatchType, ResponseValid } from 'domain/utils/ReactUtils'
import { StateType } from 'domain/types/base/base';
import { DepositoPixRequest } from 'domain/types/_carteira/deposito/depostioPixRequest';
import { DEPOSITO_PIX, DEPOSITO_DEBITO, CALCULAR_IMPOSTO, GET_MEIO_PAGAMENTO, BOLETO_GERADO, GET_BOLETOS, PAGAMENTO_PIX } from 'domain/types/_carteira/deposito/deposito';
import { DepositoService } from 'carteira/src/services/deposito/depositoService';
import ValidationResult from 'domain/types/global/validationResult';
import { CalcularImpostoRequest } from 'domain/types/_carteira/deposito/calcularImpostoRequest';
import { AppThunk } from 'base/src/utils/reducerUtil';
import { DepositoDebitoRequest } from 'domain/types/_carteira/deposito/depositoDebitoRequest';
import { DepositoCreditoRequest } from 'domain/types/_carteira/deposito/depositoCreditoRequest';
import { DEPOSITO_BOLETO, DEPOSITO_CREDITO } from 'domain/types/_carteira/deposito/deposito';
import { DepositoBoletoRequest } from 'domain/types/_carteira/deposito/depositoBoletoRequest';
import { DepositoBoletoResponse } from 'domain/types/_carteira/deposito/depositoBoletoResponse';
import { _UserData } from 'base/src/infra/storage/localStorage';
import { DepositoPixResponse } from 'domain/types/_carteira/deposito/depositoPixResponse';
import { IsDebug } from 'domain/utils/domainUtil';
import { ToastClick } from 'base/src/utils/toastUtil';
import { toast } from 'react-toastify';

const _DepositoService = new DepositoService();


export function DepositoPix(request: DepositoPixRequest, callBack: () => void): AppThunk {
  return async (dispatch) => {
    dispatch(DispatchLoading(DEPOSITO_PIX, DispatchType.LOADING, 'Gerando QR code', StateType.Master));

    const asyncResponse = await _DepositoService.DepositoPix(request, Number(request.CarteiraID));
    if (ResponseValid(asyncResponse)) {
      dispatch({
        payload: asyncResponse,
        type: DEPOSITO_PIX,
      });

      dispatch(PixCheckSSE(request.CarteiraID, (asyncResponse as DepositoPixResponse).CodigoInterno));

      callBack();
    } else {
      dispatch({
        payload: asyncResponse,
        type: DEPOSITO_PIX,
      });
      dispatch(DispatchLoading(DEPOSITO_PIX, DispatchType.ERROR, "Erro ao realizar depósito!", StateType.Master));
    }
  };
}

export function PixCheckSSE(carteiraId: number, codigoInterno: string): AppThunk {
  return async (dispatch) => {

    if (IsDebug()) {
      toast('Clique aqui para simular o pagamento do pix',
        ToastClick(
          (value) => value && _DepositoService.SimularPix_DEV(carteiraId, codigoInterno)
        )
      );
    }


    const asyncResponse = await _DepositoService.PixCheckSSE(carteiraId, codigoInterno, PAGAMENTO_PIX);
    if (ResponseValid(asyncResponse)) {
      dispatch({
        payload: asyncResponse,
        type: PAGAMENTO_PIX,
      });
    }
  };
}


export function ResetPix(): AppThunk {
  return async (dispatch) => {
    dispatch({
      payload: undefined,
      type: DEPOSITO_PIX,
    });
    dispatch({
      payload: undefined,
      type: PAGAMENTO_PIX,
    });
  };
}

export function DepositoDebito(request: DepositoDebitoRequest, callback: () => void): AppThunk {
  return async (dispatch) => {
    dispatch(DispatchLoading(DEPOSITO_DEBITO, DispatchType.LOADING, 'teste', StateType.Master));

    const carteiraID = _UserData.GetOtherData('CarteiraID');

    const asyncResponse = await _DepositoService.DepositoDebito(request, Number(carteiraID));

    if (ResponseValid(asyncResponse, false, dispatch)) {
      dispatch({
        payload: asyncResponse,
        type: DEPOSITO_DEBITO,
      });

      callback();

      dispatch(DispatchLoading(DEPOSITO_DEBITO, DispatchType.SUCCESS, "Enviado com sucesso! " + (asyncResponse as ValidationResult).Message, StateType.Master));
    }
  };
}

export function DepositoCredito(request: DepositoCreditoRequest, callback: () => void): AppThunk {
  return async (dispatch) => {
    dispatch(DispatchLoading(DEPOSITO_CREDITO, DispatchType.LOADING, 'teste', StateType.Master));

    const carteiraID = _UserData.GetOtherData('CarteiraID');
    const asyncResponse = await _DepositoService.DepositoCredito(request, Number(carteiraID));

    if (ResponseValid(asyncResponse, false, dispatch)) {
      dispatch({
        payload: asyncResponse,
        type: DEPOSITO_CREDITO,
      });

      callback();

      dispatch(DispatchLoading(DEPOSITO_CREDITO, DispatchType.SUCCESS, "Enviado com sucesso! " + (asyncResponse as ValidationResult).Message, StateType.Master));
    }
  };
}

export function DepositoBoleto(request: DepositoBoletoRequest, callback: () => void): AppThunk {
  return async (dispatch) => {

    dispatch(DispatchLoading(BOLETO_GERADO, DispatchType.LOADING, 'Processando...', StateType.Master));

    const asyncResponse = await _DepositoService.DepositoBoleto(request, request.CarteiraID, BOLETO_GERADO)

    if (IsDebug()) {
      toast('Clique aqui para simular o pagamento do boleto',
        ToastClick(
          (value) => value && _DepositoService.SimularBoleto_DEV(request.CarteiraID, (asyncResponse as DepositoBoletoResponse).TransactionId)
        )
      );
    }

    if (ResponseValid(asyncResponse)) {
      dispatch({
        payload: asyncResponse,
        type: BOLETO_GERADO
      });

      dispatch(AbrirBoleto(asyncResponse as DepositoBoletoResponse));
    }


    callback();
  }
}

export async function GetBoletoSemelhante(valor: number): Promise<DepositoBoletoResponse | null> {
  try {

    const carteiraID = _UserData.GetOtherData('CarteiraID');
    const response = await _DepositoService.GetBoletoSemelhante(Number(carteiraID), valor);

    if (ResponseValid(response, false)) {
      return response as DepositoBoletoResponse;
    } else {
      return null;
    }

  } catch (error) {
    return null;
  }
}


export function AbrirBoleto(boletoGerado: DepositoBoletoResponse): AppThunk {
  return async (dispatch) => {
    try {
      dispatch(DispatchLoading(DEPOSITO_BOLETO, DispatchType.LOADING, 'Carregando boleto...', StateType.Master));
      const response = await _DepositoService.GerarBoleto(boletoGerado as DepositoBoletoResponse);

      dispatch({
        payload: response,
        type: DEPOSITO_BOLETO,
      });

      if (typeof response === "string") {
        dispatch(DispatchLoading(DEPOSITO_BOLETO, DispatchType.ERROR, "Problema ao abrir o boleto!", StateType.Master,
          {
            CallBackText: "Clique para abrir o boleto.",
            CloseText: "Fechar",
            CallBack: () => {
              _DepositoService.AbrirBoleto(response);
            }
          }

        ));

      }

    } catch (error) {
      dispatch(DispatchLoading(DEPOSITO_BOLETO, DispatchType.ERROR, "Problema ao abrir o boleto!" + error, StateType.Master));
    }
  };
}

export function ResetBoleto(): AppThunk {
  return async (dispatch) => {
    dispatch({
      payload: null,
      type: BOLETO_GERADO,
    });
  };
}

// export function DepositoBoleto(request: DepositoBoletoRequest, callback: () => void): AppThunk {
//   return async (dispatch) => {
//     dispatch(DispatchLoading(DEPOSITO_BOLETO, DispatchType.LOADING, 'Gerando boleto, isso pode demorar um pouco...', StateType.Master));

//     // const asyncResponse = await _DepositoService.DepositoBoleto(request, Number(request.CarteiraID));

//     // if (ResponseValid(asyncResponse, false, dispatch)) {

//     //   const response = await _DepositoService.GerarBoleto(asyncResponse as DepositoBoletoResponse);

//     //   dispatch({
//     //     payload: asyncResponse,
//     //     type: DEPOSITO_BOLETO,
//     //   });


//       // if (!(response instanceof Error)) {
//       //   console.log('responseX', response);
//       //   dispatch({
//       //     payload: response,
//       //     type: BOLETO_GERADO,
//       //   });

//       //   if(response == undefined){
//       //     dispatch(DispatchLoading(DEPOSITO_BOLETO, DispatchType.SUCCESS, 'Boleto gerado com sucesso!\n Assim que o boleto for pago e processado você receberá o saldo!', StateType.Master, callback));
//       //   }

//       // } else {
//       //   dispatch(DispatchLoading(DEPOSITO_BOLETO, DispatchType.ERROR, "Erro ao gerar boleto!", StateType.Master, callback));
//       // }

//   //   }
//   // };
// }


export function CalcularImposto(request: CalcularImpostoRequest, carteiraId: number): AppThunk {
  return async (dispatch) => {
    dispatch(DispatchLoading(GET_MEIO_PAGAMENTO, DispatchType.LOADING, 'teste'));

    const asyncResponse = await _DepositoService.CalcularImposto(request, carteiraId, GET_MEIO_PAGAMENTO);

    if (ResponseValid(asyncResponse, false, dispatch)) {
      dispatch({
        payload: asyncResponse,
        type: CALCULAR_IMPOSTO,
      });
      dispatch(DispatchLoading(CALCULAR_IMPOSTO, DispatchType.SUCCESS));
    }
  };
}

export function GetMeioPagamento(carteiraId: number): AppThunk {
  return async (dispatch) => {
    dispatch(DispatchLoading(GET_MEIO_PAGAMENTO, DispatchType.LOADING, 'teste', StateType.Master));

    const asyncResponse = await _DepositoService.GetMeioPagamento(carteiraId, GET_MEIO_PAGAMENTO);

    if (ResponseValid(asyncResponse, false, dispatch)) {
      dispatch({
        payload: asyncResponse,
        type: GET_MEIO_PAGAMENTO,
      });
      dispatch(DispatchLoading(GET_MEIO_PAGAMENTO, DispatchType.SUCCESS));
    }
  };
}

export function GetBoletos(carteiraId: number): AppThunk {
  return async (dispatch) => {
    dispatch(DispatchLoading(GET_BOLETOS, DispatchType.LOADING, 'teste', StateType.Master));

    const asyncResponse = await _DepositoService.GetBoletos(carteiraId, GET_BOLETOS);

    if (ResponseValid(asyncResponse, false, dispatch)) {
      dispatch({
        payload: asyncResponse,
        type: GET_BOLETOS,
      });
      dispatch(DispatchLoading(GET_BOLETOS, DispatchType.SUCCESS));
    }
  };
}
